var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 30,
    viewBox: "0 0 196 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0516 25.2361L15.9935 25.2361L15.9935 30L0 30L0 0.0429205L6.0516 0.0429205L6.0516 25.2361Z",
    fill: "#415473"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5367 4.8927V12.4034L44.6947 12.4034V17.1674H34.5367L34.5367 25.1073H45.9915V30L28.4851 30L28.4851 0L45.9915 0V4.8927L34.5367 4.8927Z",
    fill: "#415473"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6832 0.0429205C73.8531 0.0429205 76.6339 0.658085 79.0258 1.88841C81.4464 3.11874 83.3051 4.8784 84.6019 7.16738C85.9275 9.42776 86.5903 12.0601 86.5903 15.0644C86.5903 18.0687 85.9275 20.701 84.6019 22.9614C83.3051 25.1931 81.4464 26.9242 79.0258 28.1545C76.6339 29.3848 73.8531 30 70.6832 30H60.1361L60.1361 0.0429205L70.6832 0.0429205ZM70.4671 24.8927C73.6369 24.8927 76.0864 24.0343 77.8154 22.3176C79.5445 20.6009 80.409 18.1831 80.409 15.0644C80.409 11.9456 79.5445 9.51359 77.8154 7.76824C76.0864 5.99428 73.6369 5.1073 70.4671 5.1073L66.1877 5.1073V24.8927H70.4671Z",
    fill: "#415473"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.817 4.8927V12.4034H115.975V17.1674H105.817V25.1073H117.272V30H99.7653V0L117.272 0V4.8927L105.817 4.8927Z",
    fill: "#415473"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M168.862 24.2918L156.845 24.2918L154.857 30H148.503L159.352 0L166.398 0L177.248 30H170.85L168.862 24.2918ZM167.219 19.485L162.854 6.95279L158.488 19.485L167.219 19.485Z",
    fill: "#415473"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M196 0.0429205V30H189.948V0.0429205L196 0.0429205Z",
    fill: "#415473"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a96d66530928993f4abc320a7bd25fab.svg";
export { ForwardRef as ReactComponent };